import { render, staticRenderFns } from "./StatSectionConfigForm.vue?vue&type=template&id=7b1b33fe&scoped=true&"
import script from "./StatSectionConfigForm.vue?vue&type=script&lang=js&"
export * from "./StatSectionConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b33fe",
  null
  
)

export default component.exports